<script setup lang="ts">
import { NxtInput, NxtIcon } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { useSettingsStore } from '@/apps/admin/stores/settings.store';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
const settingsStore = useSettingsStore();
const jobBoardSettingsErrors = computed(() => settingsStore.validationErrors.value);

const jobSiteUrl = computed(() => {
   const env = import.meta.env.VITE_APP_ENV;
   const value = jobBoard.value.url;

   switch (env) {
      case 'dev':
         return `https://test-job-${value}.bussup.be/`;
      case 'rel':
         return `https://release-job-${value}.bussup.be/`;
      case 'acc':
         return `https://${value}.acc.nxtpeople.jobs/`;
      case 'prod':
         return `https://${value}.nxtpeople.jobs/`;
      default:
         return ``;
   }
});
</script>

<template>
   <section>
      <div class="row">
         <div class="col-half">
            <NxtInput v-model="jobBoard.name" name="name" :label="$t('job-board.settings.name')" :errors="jobBoardSettingsErrors" />
         </div>
         <div class="col-half"></div>
      </div>
      <div class="row">
         <div class="col-half">
            <NxtInput v-model="jobBoard.url" name="url" :label="$t('job-board.settings.url')" :errors="jobBoardSettingsErrors" />
         </div>
         <div class="col-half">
            <span class="center-text">
               .nxtpeople.jobs
               <a v-if="jobBoard.is_published && jobSiteUrl" :href="jobSiteUrl" target="_blank" rel="noopener noreferrer">
                  <NxtIcon name="external-link" size="small" />
               </a>
            </span>
         </div>
      </div>
   </section>
</template>

<style scoped lang="scss">
:deep(i) {
   margin-left: var(--nxt-gutter-small);
}
</style>
